import { h } from 'preact';
import { openModal } from '../theme/modal';
import { Content as WishlistContent } from '../wishlist/content';
import { addToWishlist, createList, isInSelectedWishlist, refreshLists, removeFromWishlist } from '../wishlist';
const BUTTON_SELECTOR = '.js-wishlist-button';
const VARIANT_CHANGED_EVENT = 'product:wishlist-variant-changed';
const getButton = ()=>{
    const button = document.querySelector(BUTTON_SELECTOR);
    return button instanceof HTMLButtonElement ? button : null;
};
const parseProduct = (button)=>{
    const productJson = button.dataset.productJson;
    if (!productJson) {
        return null;
    }
    try {
        return JSON.parse(productJson);
    } catch (error) {
        console.error('Error parsing wishlist product JSON:', error);
        return null;
    }
};
const getVariantTitle = (variant)=>{
    return variant === null || variant === void 0 ? void 0 : variant.title;
};
const getVariantById = (product, variantId)=>{
    if (variantId == null) {
        return null;
    }
    const parsedVariantId = Number(variantId);
    if (!Number.isFinite(parsedVariantId)) {
        return null;
    }
    return product.variants.find((variant)=>variant.id === parsedVariantId) || null;
};
const getSwymProduct = (product, selectedVariant)=>({
        epi: selectedVariant.id,
        empi: product.id,
        du: window.location.href,
        cprops: {
            images: product.images
        }
    });
const setLoadingState = (button, isLoading)=>{
    button.setAttribute('aria-busy', String(isLoading));
    button.disabled = isLoading;
    button.classList.toggle('button__wishlist--disabled', isLoading);
};
const setWishlistState = (button, isActive)=>{
    var _button_querySelector;
    button.dataset.wishlistButton = String(isActive);
    button.setAttribute('aria-label', isActive ? 'Added to wishlist' : 'Add to wishlist');
    (_button_querySelector = button.querySelector('svg')) === null || _button_querySelector === void 0 ? void 0 : _button_querySelector.classList.toggle('wishlist__icon--active', isActive);
};
const openWishlistModal = ({ product , selectedVariant , isActive , action , wishlistName  })=>{
    openModal(h(WishlistContent, {
        targetEl: null,
        selectedVariantId: (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) || null,
        productId: product.id,
        productUrl: window.location.href,
        variantTitle: getVariantTitle(selectedVariant),
        productTitle: product.title,
        image: (product === null || product === void 0 ? void 0 : product.featured_image) || null,
        size: 'small',
        isInWishlist: isActive,
        action,
        wishlists: window.swymWishLists || [],
        product,
        wishlistName
    }), {
        ariaLabel: 'Wishlist form and details',
        id: 'wishlist-modal',
        category: 'wishlist'
    });
};
const openSelectSizeModal = (variantString)=>{
    openModal(h('p', {
        className: 'wishlist-select-size-modal__message',
        'data-testid': 'wishlist-select-size-modal'
    }, `Please select a ${variantString.toLowerCase()} to add to wishlist`), {
        ariaLabel: `Select a ${variantString.toLowerCase()} to add to wishlist`,
        id: 'wishlist-select-size-modal',
        category: 'wishlist'
    });
};
const ensureWishlist = async ()=>{
    const swat = window._swat;
    if (!swat) {
        throw new Error('Swym API not loaded');
    }
    if (window.swymSelectedListId === undefined) {
        const list = await createList(swat, undefined, true);
        window.swymSelectedListId = list.lid;
        window.swymSelectedListName = list.lname;
    }
    return swat;
};
export const init = async ()=>{
    const button = getButton();
    if (!button) {
        return;
    }
    const parsedProduct = parseProduct(button);
    if (!parsedProduct) {
        return;
    }
    let product = parsedProduct;
    let selectedVariant = getVariantById(product, button.dataset.variantId);
    let firstOptionWithoutSelectedValue = null;
    let actionWishlistLoading = false;
    const updateWishlistStatus = ()=>{
        if (!selectedVariant) {
            setWishlistState(button, false);
            return;
        }
        setWishlistState(button, isInSelectedWishlist(selectedVariant.id, product.id));
    };
    const handleVariantChanged = (event)=>{
        const detail = event.detail;
        product = detail.product;
        selectedVariant = detail.selectedVariant;
        firstOptionWithoutSelectedValue = detail.firstOptionWithoutSelectedValue;
        if (selectedVariant) {
            button.dataset.variantId = String(selectedVariant.id);
        }
        updateWishlistStatus();
    };
    const handleClick = async ()=>{
        if (actionWishlistLoading) {
            return;
        }
        const activeVariant = selectedVariant || getVariantById(product, button.dataset.variantId);
        if (!activeVariant) {
            console.error('No variant selected');
            return;
        }
        if (firstOptionWithoutSelectedValue !== null) {
            openSelectSizeModal(firstOptionWithoutSelectedValue || 'size');
            return;
        }
        const swymProduct = getSwymProduct(product, activeVariant);
        actionWishlistLoading = true;
        setLoadingState(button, true);
        try {
            const swat = await ensureWishlist();
            const newWishlistState = !isInSelectedWishlist(activeVariant.id, product.id);
            if (newWishlistState) {
                await addToWishlist(window.swymSelectedListId, swat, swymProduct);
            } else if (window.swymSelectedListId) {
                await removeFromWishlist(window.swymSelectedListId, swat, swymProduct);
            }
            await refreshLists(swat);
            setWishlistState(button, newWishlistState);
            openWishlistModal({
                product,
                selectedVariant: activeVariant,
                isActive: newWishlistState,
                action: newWishlistState ? 'added' : 'removed',
                wishlistName: window.swymSelectedListName
            });
        } catch (error) {
            console.error(error);
            updateWishlistStatus();
        } finally{
            actionWishlistLoading = false;
            setLoadingState(button, false);
        }
    };
    window.addEventListener(VARIANT_CHANGED_EVENT, handleVariantChanged);
    window.addEventListener('swym:ready', ()=>{
        updateWishlistStatus();
    });
    button.addEventListener('click', handleClick);
};
export const dispatchWishlistVariantChanged = (detail)=>{
    window.dispatchEvent(new CustomEvent(VARIANT_CHANGED_EVENT, {
        detail
    }));
};
